import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { navlinksdata } from "../../constants";
import { logo, loginPageLogo, logotrans } from "../../assets";
import Followme from "../banners/Followme";

const Navbar = () => {
  const [header, setHeader] = useState(false);
  const [delogo, setDeLogo] = useState(logo);

  const scrollHeader = () => {
    if (window.scrollY >= 20) {
      setHeader(true);
      setDeLogo(logotrans);
    } else {
      setHeader(false);
      setDeLogo(logo);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollHeader);

    return () => window.addEventListener("scroll", scrollHeader);
  }, []);

  return (
    <div
      className={
        header
          ? `w-full h-16 mx-auto px-14 md:px-5 fixed flex top-0 z-50 bg-[transparent] backdrop-blur-xl justify-between items-center duration-300`
          : `w-full h-30 mx-auto px-14 lg:px-8 md:px-5  fixed flex top-0 z-50 bg-[transparent] backdrop-blur-xl justify-between items-center`
      }
    >
      {/* <div className="flex w-[500px]">
        <h1 className="text-4xl box-border h-13 p-2 border-4 border-solid border-white text-white font-Bangers">
          Phil Page!
        </h1>
      </div> */}
      <div className="flex w-[1/3] xl:w-1/2 py-10 xl:py-2 gap-5 items-center md:hidden">
        <img
          src={loginPageLogo}
          alt="loginPageLogo"
          className={
            header
              ? `flex mt-2 animate-pulse size-44 h-auto`
              : `flex mt-2 animate-pulse  xl:w-[40%]`
          }
        />
        <div className="lg:w-1/2">
          <Followme />
        </div>
      </div>
      <div
        className={
          header
            ? `flex w-auto size-36 2xl:size-30 md:size-14 xl:size-28 pt-12 md:pt-0 opacity-60 sm:absolute sm:left-[190px] sm:top-0`
            : `flex w-auto h-48 2xl:h-40 xl:h-32 lg:h-24 opacity-80  mt-2 animate-bounce hover:animate-spin sm:absolute sm:left-[170px] sm:top-0`
        }
      >
        <img src={delogo} alt="logo" />
      </div>
      <div>
        <ul className="flex w-[1/3] items-center gap-8 xl:gap-6 lg:gap-4 md:gap-2">
          {navlinksdata.map(({ _id, title, link }) => (
            <li
              key={_id}
              className={`text-white font-Bangers underline hover:no-underline ${
                header
                  ? `text-2xl 2xl:text-xl xl:text-lg lg:text-md hover:text-3xl 2xl:hover:text-2xl xl:hover:text-xl`
                  : `text-3xl 2xl:text-2xl xl:text-xl lg:text-lg hover:text-5xl 2xl:hover:text-4xl xl:hover:text-3xl lg:hover:text-2xl md:hover:text-2xl`
              }  hover:translate-y-1 tracking-wide cursor-pointer hover:text-red-400 duration-300 delay-150 sm:hidden`}
            >
              <Link
                activeClass="active"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
